import * as THREE from 'three';

const calculateEndCoordinates = (start, direction, inclination, depth) => {
  //direction = DMSStringToDecimal(direction)+180
  //inclination = DMSStringToDecimal(inclination)
  //console.log(start, direction, inclination, depth)
  direction -= 180
  const dirRad = (parseFloat(direction) * Math.PI) / 180;
  const incRad = (parseFloat(inclination) * Math.PI) / 180;

  // const dx = depth * Math.cos(incRad) * Math.sin(dirRad);
  // const dy = depth * Math.cos(incRad) * Math.cos(dirRad);
  // const dz = depth * Math.sin(incRad);

  const dx = depth * Math.abs(Math.cos(incRad)) * Math.sin(dirRad);
  const dy = depth * Math.sin(incRad)
  const dz = depth * Math.abs(Math.cos(incRad)) * Math.cos(dirRad);

  const coords = {
    x: start.x - dx,
    y: start.y + dy,
    z: start.z + dz,
  };

 // console.log(start)
 // console.log(coords)
  return coords
};

export const transformData = ({ holes, assays }, holeColumns, assayColumns , constants) => {
  const combinedData = {};

  Object.keys(holes).forEach((holeId) => {
    const hole = holes[holeId];
    const start = {
      x: parseFloat(hole[holeColumns['X']]) - constants[0],
      y: parseFloat(hole[holeColumns['Z']]) - constants[1],
      z: -parseFloat(hole[holeColumns['Y']]) + constants[2],
    };

    //console.log(start)

    const end = calculateEndCoordinates(
      start,
      hole[holeColumns['Azimuth']],
      hole[holeColumns['Dip']],
      hole[holeColumns['Depth']],
    );

    const points = [start, end];

    const holeAssays = assays[holeId] || [];
    const transformedAssays = holeAssays
      .filter((assay) => parseFloat(assay[assayColumns['grade']]) >= 0.5)
      .map((assay) => {
      const fromPoint = calculateEndCoordinates(
        start,
        hole[holeColumns['Azimuth']],
        hole[holeColumns['Dip']],
        parseFloat(assay[assayColumns['from']])
      );

      const toPoint = calculateEndCoordinates(
        start,
        hole[holeColumns['Azimuth']],
        hole[holeColumns['Dip']],
        parseFloat(assay[assayColumns['to']])
      );

      const assayValue = parseFloat(assay[assayColumns['grade']]);
      let color;
      // if (assayValue < 1) color = 'green';
      // else if (assayValue < 3) color = 'yellow';
      // else if (assayValue >= 3) color = 'yellow';
      // else color = 'gray';

      
        if (assayValue >= 5) {
            color = 0x800080; // PURPLE
        } else if (assayValue >= 2.5) {
            color = 0xb45f06; // BROWN
        } else if (assayValue >= 1.5) {
            color = 0xcc0000; // RED
        } else if (assayValue >= 1) {
            color = 0x38761d; // GREEN
        } else {
            color = 'white'; // YELLOW
        }
        

      return {
        fromPoint,
        toPoint,
        color: new THREE.Color(color),
        data: assay,
      };
    });

    combinedData[holeId] = {
      holeId,
      points,
      assays: transformedAssays,
      data: hole,
    };
  });

  return combinedData;
};
